// Sprint U.3 placeholder — full tenant-scoped certification list ships in Sprint U.4.
import { useParams } from 'react-router-dom';

export function PortalTenantCertificationsPage() {
  const { tenantSlug } = useParams<{ tenantSlug: string }>();
  return (
    <div className="py-12 text-center">
      <p className="text-text-secondary text-sm">
        Certifications for <span className="font-medium text-text-primary">{tenantSlug}</span> — coming in Sprint U.4.
      </p>
    </div>
  );
}
